import { __decorate } from 'vscode/external/tslib/tslib.es6.js';
import { ErrorNoTelemetry, onUnexpectedError } from 'vscode/vscode/vs/base/common/errors';
import { extHostNamedCustomer } from '../../services/extensions/common/extHostCustomers.js';
import { MainContext } from 'vscode/vscode/vs/workbench/api/common/extHost.protocol';

let MainThreadErrors = class MainThreadErrors {
    dispose() {
    }
    $onUnexpectedError(err) {
        if (err && err.$isError) {
            const { name, message, stack } = err;
            err = err.noTelemetry ? ( new ErrorNoTelemetry()) : ( new Error());
            err.message = message;
            err.name = name;
            err.stack = stack;
        }
        onUnexpectedError(err);
    }
};
MainThreadErrors = __decorate([
    extHostNamedCustomer(MainContext.MainThreadErrors)
], MainThreadErrors);

export { MainThreadErrors };
